// extracted by mini-css-extract-plugin
module.exports = {"description__wrapper":"myDescription_description__wrapper__3g1aK","description__text":"myDescription_description__text__nRxH4"};